import React from 'react';
import ObfuscatedEmail from '../components/ObfuscatedEmail';
import '../styles/Terms.css'; // 이용약관과 동일한 스타일 사용

const Privacy = () => {
  return (
    <div className="terms-container">
      <div className="terms-header">
        <h1>개인정보처리방침</h1>
        <p>미라이쥬쿠는 이용자의 개인정보를 중요시하며, 「개인정보 보호법」을 준수하고 있습니다.</p>
      </div>
      
      <div className="terms-content">
        <section className="terms-section">
          <h2>1. 개인정보의 처리 목적</h2>
          <p>
            미라이쥬쿠는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
          </p>
          <ol>
            <li>회원 가입 및 관리: 회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 각종 고지·통지 등을 목적으로 개인정보를 처리합니다.</li>
            <li>서비스 제공: 입시 정보·도구 제공, 컨설팅 신청 응대, 시즌패스 신청·제공, 시즌 일정 알림(신청자에 한함) 등을 목적으로 개인정보를 처리합니다.</li>
            <li>시즌 알림: 신청한 이메일에 EJU·국비·공통테스트 등 시즌 리마인더만 발송합니다. 광고·강의 판매 목적의 메일은 보내지 않습니다.</li>
            <li>시즌패스: 신청·결제(PayPal 또는 계좌 이체) 확인에 따라 액션팩 안내와 패스 전용 시즌 알림을 발송합니다. 패스 해지·환불 요청 시 안내 범위에서 목록을 정리합니다.</li>
          </ol>
        </section>
        
        <section className="terms-section">
          <h2>2. 개인정보의 처리 및 보유 기간</h2>
          <p>
            미라이쥬쿠는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.
          </p>
          <ol>
            <li>회원 가입 및 관리: 회원탈퇴 시까지</li>
            <li>다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료 시까지
              <ul>
                <li>관계 법령 위반에 따른 수사·조사 등이 진행 중인 경우에는 해당 수사·조사 종료 시까지</li>
                <li>서비스 이용에 따른 채권·채무관계 잔존 시에는 해당 채권·채무관계 정산 시까지</li>
              </ul>
            </li>
            <li>전자상거래 등에서의 소비자 보호에 관한 법률에 따른 표시·광고, 계약내용 및 이행 등 거래에 관한 기록
              <ul>
                <li>표시·광고에 관한 기록: 6개월</li>
                <li>계약 또는 청약철회, 대금결제, 재화 등의 공급기록: 5년</li>
                <li>소비자 불만 또는 분쟁처리에 관한 기록: 3년</li>
              </ul>
            </li>
          </ol>
        </section>
        
        <section className="terms-section">
          <h2>3. 개인정보의 제3자 제공</h2>
          <p>
            미라이쥬쿠는 정보주체의 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.
          </p>
        </section>
        
        <section className="terms-section">
          <h2>4. 개인정보처리 위탁</h2>
          <p>
            미라이쥬쿠는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.
          </p>
          <ol>
            <li>결제 서비스: 결제대행사</li>
            <li>서버 호스팅: 클라우드 서비스 제공업체</li>
            <li>이메일 발송: 이메일 서비스 제공업체</li>
          </ol>
        </section>
        
        <section className="terms-section">
          <h2>5. 정보주체와 법정대리인의 권리·의무 및 그 행사방법</h2>
          <p>
            정보주체는 미라이쥬쿠에 대해 언제든지 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다.
          </p>
          <p>
            권리 행사는 미라이쥬쿠에 대해 「개인정보 보호법」 시행령 제41조제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며, 미라이쥬쿠는 이에 대해 지체 없이 조치하겠습니다.
          </p>
          <p>
            권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수도 있습니다. 이 경우 "개인정보 처리 방법에 관한 고시(제2020-7호)" 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.
          </p>
        </section>
        
        <section className="terms-section">
          <h2>6. 처리하는 개인정보의 항목</h2>
          <p>
            미라이쥬쿠는 다음의 개인정보 항목을 처리하고 있습니다.
          </p>
          <ol>
            <li>회원 가입 및 관리
              <ul>
                <li>필수항목: 이름, 이메일, 비밀번호</li>
                <li>선택항목: 프로필 이미지, 전화번호</li>
              </ul>
            </li>
            <li>서비스 이용 과정에서 아래 개인정보 항목이 자동으로 생성되어 수집될 수 있습니다.
              <ul>
                <li>IP 주소, 쿠키, 서비스 이용 기록, 방문 기록, 불량 이용 기록 등</li>
              </ul>
            </li>
          </ol>
        </section>
        
        <section className="terms-section">
          <h2>7. 개인정보의 파기</h2>
          <p>
            미라이쥬쿠는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.
          </p>
          <p>
            정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.
          </p>
        </section>
        
        <section className="terms-section">
          <h2>8. 개인정보의 안전성 확보 조치</h2>
          <p>
            미라이쥬쿠는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.
          </p>
          <ol>
            <li>관리적 조치: 내부관리계획 수립·시행, 정기적 직원 교육 등</li>
            <li>기술적 조치: 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치</li>
            <li>물리적 조치: 전산실, 자료보관실 등의 접근통제</li>
          </ol>
        </section>
        
        <section className="terms-section">
          <h2>9. 개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항</h2>
          <p>
            미라이쥬쿠는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다.
          </p>
          <p>
            쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다.
          </p>
          <p>
            이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.
          </p>
        </section>
        
        <section className="terms-section">
          <h2>10. 개인정보 보호책임자</h2>
          <p>
            미라이쥬쿠는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
          </p>
          <ul>
            <li>개인정보 보호책임자: 박민준</li>
            <li>이메일: <ObfuscatedEmail /></li>
          </ul>
        </section>
        
        <section className="terms-section">
          <h2>11. 개인정보 열람청구</h2>
          <p>
            정보주체는 「개인정보 보호법」 제35조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수 있습니다. 미라이쥬쿠는 정보주체의 개인정보 열람청구가 신속하게 처리되도록 노력하겠습니다.
          </p>
          <ul>
            <li>개인정보 열람청구 접수·처리 부서: 고객지원팀</li>
            <li>이메일: <ObfuscatedEmail /></li>
          </ul>
        </section>
        
        <section className="terms-section">
          <h2>12. 권익침해 구제방법</h2>
          <p>
            정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다.
          </p>
          <ul>
            <li>개인정보분쟁조정위원회: 1833-6972 (www.kopico.go.kr)</li>
            <li>개인정보침해신고센터: 118 (privacy.kisa.or.kr)</li>
            <li>대검찰청: 1301 (www.spo.go.kr)</li>
            <li>경찰청: 182 (ecrm.cyber.go.kr)</li>
          </ul>
        </section>
        
        <div className="terms-footer">
          <p>본 개인정보처리방침은 2024년 5월 1일부터 시행합니다.</p>
        </div>
      </div>
    </div>
  );
};

export default Privacy; 